// extracted by mini-css-extract-plugin
export var contentBody = "_dh-9";
export var headerImage = "_dh-2";
export var imageButton = "_dh-7";
export var imageButtonIcon = "_dh-8";
export var imageHeader = "_dh-4";
export var imageHeaderText = "_dh-5";
export var imageOverlay = "_dh-3";
export var imageTitle = "_dh-6";
export var imageWrapper = "_dh-1";
export var taskList = "_dh-a";
export var widget = "_dh-0";